export const attandanceadmindata = [
  {
    id:"1",
    Employee: "Carl Evans",
    image:"user-01.jpg",
    Role: "Designer",
    Status: "Present",
    Clock_In: "09:00 AM",
    Clock_Out: "07:15 PM",
    Production: "09h 00m",
    Break: "0h 45m",
    Overtime: "0h 20m",
    Total_Hours: "09h 20m",
  },
  {
    id:"2",
    Employee: "Minerva Rameriz",
    image:"user-06.jpg",
    Role: "Administrator",
    Status: "Present",
    Clock_In: "09:15 AM",
    Clock_Out: "07:12 PM",
    Production: "09h 00m",
    Break: "01h 15m",
    Overtime: "0h 12m",
    Total_Hours: "09h 12m",
  },
  {
    id:"3",
    Employee: "Robert Lamon",
    image:"user-04.jpg",
    Role: "Developer",
    Status: "Present",
    Clock_In: "09:40 AM",
    Clock_Out: "07:00 PM",
    Production: "08h 45m",
    Break: "01h 00m",
    Overtime: "00h 00m",
    Total_Hours: "08h 45m",
  },
  {
    id:"4",
    Employee: "Patricia Lewis",
    image:"user-03.jpg",
    Role: "HR Manager",
    Status: "Present",
    Clock_In: "09:45 AM",
    Clock_Out: "08:10 PM",
    Production: "09h 12m",
    Break: "00h 50m",
    Overtime: "00 14m",
    Total_Hours: "09h 14m",
  },
  {
    id:"5",
    Employee: "Mark Joslyn",
    image:"user-05.jpg",
    Role: "Designer",
    Status: "Absent",
    Clock_In: "-",
    Clock_Out: "-",
    Production: "-",
    Break: "-",
    Overtime: "-",
    Total_Hours: "-",
  },
  {
    id:"6",
    Employee: "Marsha Betts",
    image:"user-05.jpg",
    Role: "Developer",
    Status: "Present",
    Clock_In: "09:17 AM",
    Clock_Out: "07:34 PM",
    Production: "09h 26m",
    Break: "01h 20m",
    Overtime: "00h 26m",
    Total_Hours: "09h 26m",
  },
  {
    id:"7",
    Employee: "Daniel Jude ",
    image:"user-28.jpg",
    Role: "HR Assistant",
    Status: "Absent",
    Clock_In: "-",
    Clock_Out: "-",
    Production: "-",
    Break: "-",
    Overtime: "-",
    Total_Hours: "-",
  },
  {
    id:"8",
    Employee: "Emma Bates",
    image:"user-12.jpg",
    Role: "HR Assistant",
    Status: "Present",
    Clock_In: "09:42 AM",
    Clock_Out: "07:20 PM",
    Production: "09h 17m",
    Break: "01h 00m",
    Overtime: "00h 17m",
    Total_Hours: "09h 17m",
  },
  {
    id:"9",
    Employee: "Richard Fralick ",
    image:"user-30.jpg",
    Role: "Designer",
    Status: "Present",
    Clock_In: "09:18 AM",
    Clock_Out: "07:11 PM",
    Production: "09h 32m",
    Break: "01h 15m",
    Overtime: "00h 32m",
    Total_Hours: "09h 32m",
  },
  {
    id:"10",
    Employee: "Michelle Robison",
    image:"user-26.jpg",
    Role: "HR Manager",
    Status: "Present",
    Clock_In: "09:30 AM",
    Clock_Out: "08:10 PM",
    Production: "09h 00m",
    Break: "00h 34m",
    Overtime: "00h 20m",
    Total_Hours: "09h 20m",
  },
];
